import {
  LuHouse,
  LuLayoutGrid,
  LuMessageCircle,
  LuLayers,
  LuUser,
  LuSettings,
  LuCircleHelp,
  LuPencilLine,
} from 'react-icons/lu';

/**
 * Single source of truth for navigation.
 * Desktop nav, mobile header menu, bottom nav, search and profile menu all
 * read from here so labels, order and icons can never drift apart.
 */
export const PRIMARY_NAV = [
  { key: 'home', label: 'Home', to: '/', icon: LuHouse },
  { key: 'dashboard', label: 'Dashboard', to: '/dashboard', icon: LuLayoutGrid },
  { key: 'chatbot', label: 'Chatbot', to: '/chatbot', icon: LuMessageCircle },
  { key: 'plans', label: 'Plans', to: '/plans', icon: LuLayers },
  { key: 'help', label: 'Help', to: '/help', icon: LuCircleHelp },
];

/** Mobile bottom bar — matches the reference's five destinations. */
export const BOTTOM_NAV = [
  { key: 'home', label: 'Home', to: '/', icon: LuHouse },
  { key: 'dashboard', label: 'Dashboard', to: '/dashboard', icon: LuLayoutGrid },
  { key: 'chatbot', label: 'Chatbot', to: '/chatbot', icon: LuMessageCircle },
  { key: 'plans', label: 'Plans', to: '/plans', icon: LuLayers },
  { key: 'profile', label: 'Profile', to: '/profile', icon: LuUser },
];

export const ACCOUNT_NAV = [
  { key: 'profile', label: 'Profile', to: '/profile', icon: LuUser },
  { key: 'profile-edit', label: 'Edit profile', to: '/profile/edit', icon: LuPencilLine },
  { key: 'settings', label: 'Settings', to: '/settings', icon: LuSettings },
  { key: 'plans', label: 'Subscription plans', to: '/plans', icon: LuLayers },
  { key: 'help', label: 'Help & support', to: '/help', icon: LuCircleHelp },
];

export const SEARCH_INDEX = [
  ...PRIMARY_NAV,
  ...ACCOUNT_NAV.filter((item) => !PRIMARY_NAV.some((p) => p.to === item.to)),
];
